/**
 * These are generic selection styles for all nodes
 * If you have custom behaviour needed for a node, add that in the plugin's styles
 * file in editor-core
 */
export enum SelectionStyle {
	Border,
	BoxShadow,
	Background,
	Blanket,
}
